module.exports = __webpack_public_path__ + "static/media/lamp.c27f3ab1.svg";